/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:05:09
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/rate.js
 */
export default {
    // rate组件
    rate: {
        value: 1,
        count: 5,
        disabled: false,
        size: 18,
        inactiveColor: '#b2b2b2',
        activeColor: '#FA3534',
        gutter: 4,
        minCount: 1,
        allowHalf: false,
        activeIcon: 'star-fill',
        inactiveIcon: 'star',
        touchable: true
    }
}
